module.exports = __webpack_public_path__ + "img/篮球国家队人才库.44c6e0a6.png";